// Посещение приложения при наличии token
export const trackAppVisit = (userId: number, phoneNumber: string) => {
  const userData = {
    userId,
    phoneNumber,
  }

  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      app_visit: userData,
    })
  }
}

// посещение карточки товара
export const trackProductCard = (userId: number, phoneNumber: string) => {
  const userData = {
    userId,
    phoneNumber,
  }

  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      product_card: userData,
    })
  }
}

// посещение корзины
export const trackCart = (userId: number, phoneNumber: string) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      cart: userData,
    })
  }
}

// посещение корзины по id
export const trackCartById = (userId: number, phoneNumber: string) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      cart_by_id: userData,
    })
  }
}

// Посещение страницы оформление заказа
export const trackOrderCreate = (userId: number, phoneNumber: string) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      order_create: userData,
    })
  }
}

// Количество времени посещения на странице оформления заказа
export const trackOrderCreateVisitDuration = (
  userId: number,
  phoneNumber: string,
  visitDuration: number,
) => {
  const userData = {
    userId,
    phoneNumber,
    visitDuration,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      order_create_visit_duration: userData,
    })
  }
}

// перейти к оплате
export const trackPlaceOnOrderByMbank = (
  userId: number,
  phoneNumber: string,
) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      go_to_payment_by_mbank: userData,
    })
  }
}
// перейти к оплате оформить в м+
export const trackPlaceOnOrderByMPlus = (
  userId: number,
  phoneNumber: string,
) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      go_to_payment_by_mplus: userData,
    })
  }
}

// клик по кнопке взять м+ в оформление
export const trackTakeMPlus = (userId: number, phoneNumber: string) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      take_mplus: userData,
    })
  }
}
// клик по кнопке подключить м+ в оформление
export const trackConnectMPlus = (userId: number, phoneNumber: string) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      connect_mplus: userData,
    })
  }
}
// клик по кнопке открыть м+ в модальном окне
export const trackOpenMPlus = (userId: number, phoneNumber: string) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      open_mplus: userData,
    })
  }
}

export const trackSearchResults = (userId: number, phoneNumber: string) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      search_results: userData,
    })
  }
}

export const trackCategory = (
  userId: number,
  phoneNumber: string,
  category: string,
) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      category: {
        ...userData,
        category,
      },
    })
  }
}

export const trackProductCardFromCollection = (
  userId: number,
  phoneNumber: string,
) => {
  const userData = {
    userId,
    phoneNumber,
  }
  if (window.ym) {
    window.ym(96920986, 'reachGoal', 'order', {
      userData,
      collection: {
        ...userData,
        fromCollection: true,
      },
    })
  }
}
